import React from 'react';
import { EtapaConfiguracoesAvancadasProps } from './types';

const EtapaConfiguracoesAvancadas: React.FC<EtapaConfiguracoesAvancadasProps> = ({
  formData,
  onInputChange,
  onToggleGlobal,
  slideDirection,
  configGlobal
}) => {
  return (
    <div style={{
      animation: slideDirection === 'right' ? 'slideInRight 0.3s ease-out' : 'slideInLeft 0.3s ease-out'
    }}>
      <div className="mb-3" style={{
        border: '1px solid #b7ebc6',
        background: '#ecfdf3',
        borderRadius: '10px',
        padding: '10px 12px'
      }}>
        <div className="form-check form-switch mb-0">
          <input
            className="form-check-input"
            type="checkbox"
            id="usar-config-especifica-processo"
            checked={!formData.usarConfiguracaoGlobalAcessoCandidato}
            onChange={(e) => onToggleGlobal(!e.target.checked)}
            style={{
              backgroundColor: !formData.usarConfiguracaoGlobalAcessoCandidato ? '#198754' : undefined,
              borderColor: !formData.usarConfiguracaoGlobalAcessoCandidato ? '#198754' : undefined
            }}
          />
          <label className="form-check-label fw-semibold d-flex align-items-center gap-2" htmlFor="usar-config-especifica-processo" style={{ fontSize: '14px' }}>
            Usar configurações específicas para este Processo
          </label>
        </div>
      </div>

      {formData.usarConfiguracaoGlobalAcessoCandidato && (
        <div style={{
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '10px',
          padding: '14px 16px',
          fontSize: '13px',
          color: '#495057',
          lineHeight: 1.6,
        }}>
          <strong>Configuração global ativa.</strong> Este processo utilizará os valores definidos na configuração geral do sistema (menu Configurações):
          <ul style={{ marginTop: '8px', marginBottom: 0, paddingLeft: '20px' }}>
            <li>Liberação do link da sala de espera: <strong>{configGlobal?.janelaLiberacaoHoras ?? 3} horas</strong> antes da banca virtual</li>
            <li>Formulário de recurso por e-mail: <strong>{configGlobal?.envioFormularioRecursoPorEmail ? 'Habilitado' : 'Desabilitado'}</strong></li>
            <li>Prazo de interposição de recurso: <strong>3 horas</strong> (padrão)</li>
          </ul>
          <div style={{ marginTop: '8px', color: '#6c757d' }}>
            Alterações na configuração global serão refletidas automaticamente neste processo.
          </div>
        </div>
      )}

      {!formData.usarConfiguracaoGlobalAcessoCandidato && (
        <div className="d-flex flex-column gap-4">
          {/* Acesso do Candidato */}
          <div>
            <div className="fw-semibold mb-2" style={{ fontSize: '13px', color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Acesso do Candidato
            </div>
            <div className="d-flex flex-column gap-3">
              <div>
                <label className="form-label fw-semibold mb-2 d-flex align-items-center gap-2" style={{ fontSize: '14px', color: '#495057' }}>
                  <i className="bi bi-clock-history"></i>
                  Antecedência para liberar o link da sala de espera (horas)
                </label>
                <input
                  type="number"
                  min={1}
                  className="form-control modern-input"
                  value={formData.janelaLiberacaoHoras}
                  onChange={(e) => onInputChange('janelaLiberacaoHoras', e.target.value)}
                />
                <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '6px', lineHeight: 1.4 }}>
                  Para a janela da Sala do Processo funcionar como esperado nesta estratégia, as bancas virtuais devem ocorrer no mesmo dia.
                  Bancas em dias posteriores terão liberação do link no mesmo dia da primeira banca virtual do processo.
                </div>
              </div>
            </div>
          </div>

          {/* Recursos */}
          <div>
            <div className="fw-semibold mb-2" style={{ fontSize: '13px', color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Recursos
            </div>
            <div className="d-flex flex-column gap-3">
              <div>
                <label className="form-label fw-semibold mb-2 d-flex align-items-center gap-2" style={{ fontSize: '14px', color: '#495057' }}>
                  <i className="bi bi-hourglass-split"></i>
                  Prazo para o candidato interpor recurso
                </label>
                <div className="d-flex gap-2">
                  <input
                    type="number"
                    min={1}
                    className="form-control modern-input"
                    value={formData.prazoInterposicaoRecursoValor}
                    onChange={(e) => onInputChange('prazoInterposicaoRecursoValor', e.target.value)}
                  />
                  <select
                    className="form-select modern-input"
                    value={formData.prazoInterposicaoRecursoUnidade}
                    onChange={(e) => onInputChange('prazoInterposicaoRecursoUnidade', e.target.value)}
                    style={{ maxWidth: '140px' }}
                  >
                    <option value="HORAS">Horas</option>
                    <option value="DIAS">Dias</option>
                  </select>
                </div>
                <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '6px', lineHeight: 1.4 }}>
                  Tempo que o candidato terá, após receber o resultado, para enviar um recurso.
                </div>
              </div>

              <div className="edital-card">
                <div className="form-check form-switch mb-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="envio-form-recurso-email"
                    checked={formData.envioFormularioRecursoPorEmail}
                    onChange={(e) => onInputChange('envioFormularioRecursoPorEmail', e.target.checked.toString())}
                  />
                  <label className="form-check-label d-flex align-items-center gap-2" htmlFor="envio-form-recurso-email" style={{ fontSize: '14px' }}>
                    <i className="bi bi-envelope-check-fill"></i>
                    Enviar link do formulário de recurso junto com o e-mail de resultado
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* Notificações */}
          <div>
            <div className="fw-semibold mb-2" style={{ fontSize: '13px', color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Notificações
            </div>
            <div className="edital-card">
              <div className="form-check form-switch mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="envio-auto-resultados-etapa"
                  checked={formData.envioAutomaticoResultadoPorEtapaHabilitado}
                  onChange={(e) => onInputChange('envioAutomaticoResultadoPorEtapaHabilitado', e.target.checked.toString())}
                />
                <label className="form-check-label d-flex align-items-center gap-2" htmlFor="envio-auto-resultados-etapa" style={{ fontSize: '14px' }}>
                  <i className="bi bi-send-check-fill"></i>
                  Notificar candidatos automaticamente ao final de cada etapa
                </label>
              </div>
              <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '6px', paddingLeft: '40px', lineHeight: 1.4 }}>
                Envia e-mail de resultado ao candidato quando todas as bancas de uma etapa (Facial, Virtual ou Recursal) forem concluídas.
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EtapaConfiguracoesAvancadas;
